var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{staticClass:"core-main"},[_c('div',{attrs:{"id":"core-view"}},[_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('nuxt')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }